module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/history/suggestion-history/suggestion-history.component.css
// module id = ./src/app/modules/history/suggestion-history/suggestion-history.component.css
// module chunks = main